/**
 * Cookie/consent state for non-essential trackers (GA4 + Meta Pixel).
 *
 * Under UK PECR + UK GDPR these are non-essential and must not load before the
 * user opts in. We persist a single decision in localStorage and gate
 * `initAnalytics()` / attribution capture on it. "rejected" and "undecided"
 * both mean: load nothing.
 */

const CONSENT_KEY = "qr_cookie_consent";

export type ConsentDecision = "accepted" | "rejected";

export function getConsent(): ConsentDecision | null {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(CONSENT_KEY);
    return v === "accepted" || v === "rejected" ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(decision: ConsentDecision): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(CONSENT_KEY, decision);
  } catch {
    // Storage unavailable (private mode / quota) — consent is best-effort.
  }
}

export const hasConsent = (): boolean => getConsent() === "accepted";
